import { sendXray } from 'reactApp/utils/ga';

export const sendGaUploaderNew = (action: string, label = '', iData: Record<string, any> | null | number | string = null) =>
    sendXray(['uploader', action, label], typeof iData === 'number' ? { i: iData } : iData);
